// @flow
import PropTypes from "prop-types";
import LIUtils from "../SUPPORT/LIUtils";

const DashboardButton = ({icon, onClick, title, subTitle, special, danger, warn, disabled, image, colorClass="li-primary", medium,
                         upperRightIcon, upperRightIconTip}) => {
    
    const sizeClass = (medium?"li-font-medium-large":"");
    
    function subTitleIfAny() {
        if(LIUtils.existsAndNotEmpty(subTitle)) {
            return(
                <div className="d-block badge rounded-pill li-bg-white li-fg-darker li-font-medium mt-2 ml-auto mr-auto"
                style={{width:"fit-content"}}>{subTitle}</div>  
            );
        }
        return null;
    }
    
    function showUpperRightIconIfRequired() {
        if(LIUtils.existsAndNotEmpty(upperRightIcon)) {
            return(
                <div className="position-absolute" style={{right:"25px",top:"8px"}}>
                    <span className={"fa "+upperRightIcon} aria-hidden="true" 
                          data-toggle="tooltip" data-placement="top" title={upperRightIconTip}/>
                </div>
            );
        }
        return null;
    }
    
    function handleOnClick(e) {
        if(onClick && !disabled) {
            onClick(e);
        }
    }
    
    let bgClass = (special?"li-bg-admin":danger?"li-secondary":warn?"li-warn":colorClass);
    if(disabled) {
        bgClass = "li-bg-muted";
    }
    
    return(
        <div className={"position-relative li-dash-button text-center "+bgClass+" "+sizeClass} onClick={handleOnClick}>
            {showUpperRightIconIfRequired()}
            {icon && <i className={"mb-3 fa "+icon} aria-hidden="true"/>}
            {image && <img src={image} className="li-dash-button-image" alt="dashboard button"/>}
            <div>{title}{subTitleIfAny()}</div>
        </div>
    );
}

DashboardButton.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.oneOfType([PropTypes.string,PropTypes.object]),
    onClick: PropTypes.func,
    special: PropTypes.bool,
    disabled: PropTypes.bool,
    image: PropTypes.string,
    danger: PropTypes.bool,
    warn: PropTypes.bool,
    colorClass: PropTypes.string,
    upperRightIcon: PropTypes.string,
    upperRightIconTip: PropTypes.string
}

export default DashboardButton;
        
        
